import script from "./UiModalShell.vue?vue&type=script&setup=true&lang=js"
export * from "./UiModalShell.vue?vue&type=script&setup=true&lang=js"

import "./UiModalShell.vue?vue&type=style&index=0&id=2ccf708e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ccf708e"]])

export default __exports__